import "waypoints/lib/jquery.waypoints.min.js";
import "waypoints/lib/shortcuts/inview.min.js";
import { isMobile } from "./isMobile";

/*
 *
 * ----------------------------------------------- */
// <script>タグを生成
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var players = {};

window.onYouTubeIframeAPIReady = function () {
  jQuery(function ($) {
    $("[data-youtube-id]").each(function (i, val) {
      var id = $(val).attr("id"); // iframe id

      players[id] = {
        onReady: false,
        player: new YT.Player(id, {
          width: 340,
          height: 200,
          videoId: $(val).data("youtube-id"),
          playerVars: {
            // autoplay: 1,
            // controls: 0,
            // playsinline: 1,
            enablejsapi: 1,
          },
          events: {
            onReady: onPlayerReady,
            // onStateChange: onPlayerStateChange,
          },
        }),
      };

      new Waypoint.Inview({
        element: $("#" + id)[0],
        enter: function (direction) {
          playYoutube(this);
        },
        entered: function (direction) {
          playYoutube(this);
        },
        exited: function (direction) {
          if (isMobile()) {
            var id = this.element.id;

            if (players[id].onReady) {
              players[id].player.pauseVideo();
            }
          }
        },
      });
    });
  });

  /*
   *
   * ----------------------------------------------- */
  jQuery(function ($) {
    $(".thumbnail-header iframe").each(function (index, value) {
      $(this).hover(
        function () {
          $(this).data("src-orig", $(this).attr("src"));
          $(this).attr("src", $(this).data("src-orig") + "?autoplay=1&mute=1");
        },
        function () {
          $(this).attr("src", $(this).data("src-orig"));
        }
      );
    });
  });
};

/*
 *
 * ----------------------------------------------- */
function playYoutube(_this) {
  if (isMobile()) {
    var id = _this.element.id;

    if (players[id].onReady) {
      players[id].player.mute();
      players[id].player.playVideo();
    }
  }
}

/*
 *
 * ----------------------------------------------- */
function onPlayerReady(event) {
  var id = event.target.getIframe().id;
  players[id].onReady = true;
}

/*
 *
 * ----------------------------------------------- */
function onPlayerStateChange(event) {
  console.log(event.data);
  // if (event.data == YT.PlayerState.PLAYING && !done) {
  // }
}

/*
 *
 * ----------------------------------------------- */
let prevRatio = 0.0;
const increasingColor = "rgba(40, 40, 190, ratio)";
const decreasingColor = "rgba(190, 40, 40, ratio)";

// Set things up
window.addEventListener(
  "load",
  (event) => {
    createObserver();
  },
  false
);

/*
 *
 * ----------------------------------------------- */
function createObserver() {
  let observer;

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: buildThresholdList(),
  };

  var elements = document.querySelector("[data-youtube-id]");

  if (elements) {
    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(elements);
  }
}

/*
 *
 * ----------------------------------------------- */
function buildThresholdList() {
  const thresholds = [];
  const numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;
    thresholds.push(ratio);
  }

  // console.log(thresholds);

  thresholds.push(0);
  return thresholds;
}

/*
 *
 * ----------------------------------------------- */
function handleIntersect(entries, observer) {
  entries.forEach((entry) => {
    if (isMobile()) {
      var id = entry.target.id;

      if (players[id].onReady) {
        players[id].player.mute();
        players[id].player.playVideo();
      }
    }

    prevRatio = entry.intersectionRatio;
  });
}
